import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"10px","text-align":"left"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { style: {"padding":"20px"} }
const _hoisted_8 = { style: {"padding":"10px","background-color":"#FAFAFA","text-align":"center"} }
const _hoisted_9 = { style: {"padding-top":"20px","padding-left":"10","padding-right":"10"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, "下级代理 ", -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { style: {"padding":"10px","background-color":"#FAFAFA","text-align":"center"} }

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { addAgent, allGeneralAgent, disableUsers,allAgentMyUserActivity,officialSettlementDccounts,adminOneClickLogin,allAdminMyAgent,getMeasure } from '../../api'
  import { setToken,setUserName } from '../../utils/auth' 

 
export default /*#__PURE__*/_defineComponent({
  __name: 'generalAgentList',
  setup(__props) {

  const copyToClipboard=(text:any)=> {
  const textarea = document.createElement('textarea');
    textarea.value = text;
    // 将 textarea 添加到 body 中
    document.body.appendChild(textarea);
    // 选中 textarea 中的内容
    textarea.select();
    // 执行复制命令
    document.execCommand('copy');
    // 移除 textarea 元素
    document.body.removeChild(textarea);
    layer.msg('复制成功')
}


//代理信息

const  isGeneralAgent=ref(false); 
  
const agentMyUserActivity = reactive({ 
  userName: "", 
  proportion: 0, 
  numberSubagents: 0, 
  visitsToday: 0 ,
  totalVisits: 0, 
  todayIp: 0, 
  totalIp: "", 
  totalDowds: 0, 
  dowdsToday:0,
  inviteToday: 0, 
  totalInvite: 0, 
  registerToday: 0, 
  totalRegister: 0, 
  open: 0, 
  closed: 0, 
  threeDays: 0, 
  sevenDays: 0, 
  thirtyDays: 0, 
  univalent:0,
  origin:"", 
  closedTotalDowds:0,
  closedTotalInvite:0,
  closedTotalRegister:0,
  userId:"",
  totalRecharge:0,
  quantity:0,

   

});




  const check = (row: any) => { 


      agentMyUserActivity.userName=row.userName;
      agentMyUserActivity.proportion=row.proportion;
      agentMyUserActivity.numberSubagents=row.numberSubagents;
      agentMyUserActivity.visitsToday=row.visitsToday;
      agentMyUserActivity.totalVisits=row.totalVisits;
      agentMyUserActivity.todayIp=row.todayIp;
      agentMyUserActivity.totalIp=row.totalIp;
      agentMyUserActivity.dowdsToday=row.dowdsToday;
      agentMyUserActivity.totalDowds=row.totalDowds;
      agentMyUserActivity.inviteToday=row.inviteToday;
      agentMyUserActivity.totalInvite=row.totalInvite;
      agentMyUserActivity.registerToday=row.registerToday; 
      agentMyUserActivity.totalRegister=row.totalRegister; 
      agentMyUserActivity.open=row.open; 
      agentMyUserActivity.closed=row.closed;
      agentMyUserActivity.univalent=row.univalent;
      agentMyUserActivity.origin=row.origin;
      
      agentMyUserActivity.closedTotalDowds=row.closedTotalDowds;
      agentMyUserActivity.closedTotalInvite=row.closedTotalInvite;
      agentMyUserActivity.closedTotalRegister=row.closedTotalRegister;
      agentMyUserActivity.userId=row.userId;
      agentMyUserActivity.totalRecharge=row.totalRecharge;
      agentMyUserActivity.quantity=row.quantity;
      
    
      
      

      isGeneralAgent.value=true;
      var index = layer.load(0,)
      var data = { "key": row.userId };
      getAllAdminUser();
 
       
        allAgentMyUserActivity(JSON.stringify(data)).then((res: any) => {
          layer.close(index);
          if (res != "" && res.code == 0) { 
            agentMyUserActivity.threeDays=res.data.threeDays;
            agentMyUserActivity.sevenDays=res.data.sevenDays;
            agentMyUserActivity.thirtyDays=res.data.thirtyDays; 
            
          }
        }) 

}

const dataSourceAgent = ref([]);
const pageAgent = reactive({ current: 1, limit: 10, total: 0 });

const columnsAgent = ref([
    { title: "账号", key: "userName", align: "center",width: "100px" },
    { title: "状态", key: "state", align: "center", customSlot: "state" },   
    { title: "推广地址", key: "invitationCode", align: "center" , customSlot: "invitationCode",width: "150px"},  
    { title: "今预览", key: "visitsToday", align: "center"},
    { title: "总预览", key: "totalVisits", align: "center"},
    { title: "今ip", key: "todayIp", align: "center"},
    { title: "总ip", key: "totalIp", align: "center"},
    { title: "今下载", key: "dowdsToday", align: "center"},
    { title: "总下载", key: "totalDowds", align: "center" , customSlot: "totalDowds" },
    // { title: "已结下载", key: "closedTotalDowds", align: "center" },
    { title: "今安装", key: "inviteToday", align: "center"},
    { title: "总安装", key: "totalInvite", align: "center" , customSlot: "totalInvite"},
    // { title: "已结安装", key: "closedTotalInvite", align: "center" },
    { title: "今注册", key: "registerToday", align: "center"},
    { title: "总注册", key: "totalRegister", align: "center", customSlot: "totalRegister"},
    // { title: "已结注册", key: "closedTotalRegister", align: "center" },   
    { title: "总充值", key: "totalRecharge", align: "center" },  
    { title: "总扣量", key: "quantity", align: "center" },  
  ]);


  const getAllAdminUser = () => {
  loading.value = true;
  var data = { "page": pageAgent.current, "limit": pageAgent.limit, "keyWord": agentMyUserActivity.userId };
  allAdminMyAgent(JSON.stringify(data)).then((res: any) => {
    loading.value = false;
    if (res != "" && res.code == 0) {
      dataSourceAgent.value = res.data;
      pageAgent.total = res.count;
    } else {
      dataSourceAgent.value = [];
      pageAgent.total = 0;
    }
  })
}


  
const changeAdminMyAgent = (page: any) => {
  getAllAdminUser();
  }







  const search = reactive({
    key: "",
  })
  
  
  const loading = ref(false);
  
  const dataSource = ref([]);
  
  const selectedKeys = ref([]);
  
  const page = reactive({ current: 1, limit: 10, total: 0 });
  
  const columns = ref([
    { title: "账号", key: "userName", align: "center" },
    { title: "推广地址", key: "invitationCode", align: "center" , customSlot: "invitationCode",width: "150px"},
    { title: "验证方式", key: "verify", align: "center", customSlot: "verifyStr",ellipsisTooltip: true,width: "100px"},
    { title: "来源验证", key: "origin", align: "center",ellipsisTooltip: true,width: "100px"}, 
    { title: "扣量条件", key: "proportion", align: "center"}, 
    { title: "代理数", key: "numberSubagents", align: "center"},
      { title: "今logo", key: "todaylogo", align: "center"},
    { title: "总logo", key: "totallogo", align: "center"},
    { title: "今预览", key: "visitsToday", align: "center"},
    { title: "总预览", key: "totalVisits", align: "center"},
    { title: "今ip", key: "todayIp", align: "center"},
    { title: "总ip", key: "totalIp", align: "center"},
    { title: "今下载", key: "dowdsToday", align: "center"},
    { title: "总下载", key: "totalDowds", align: "center" , customSlot: "totalDowds" },
    // { title: "已结下载", key: "closedTotalDowds", align: "center" },
    { title: "今安装", key: "inviteToday", align: "center"},
    { title: "总安装", key: "totalInvite", align: "center" , customSlot: "totalInvite"},
    // { title: "已结安装", key: "closedTotalInvite", align: "center" },
    { title: "今注册", key: "registerToday", align: "center"},
    { title: "总注册", key: "totalRegister", align: "center", customSlot: "totalRegister"},
    // { title: "已结注册", key: "closedTotalRegister", align: "center" },   
    { title: "单价", key: "univalent", align: "center" },
    { title: "总充值", key: "totalRecharge", align: "center" }, 
    { title: "状态", key: "state", align: "center", customSlot: "state" },    
    { title: "备注", key: "generalRemark", align: "center" },
    { title: "结算时间", key: "officialSettlementTime", align: "center" }, 
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" , width: "220px"}
  ]);
  
  
  const getAllGeneralAdminUser = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit, "key": search.key };
    allGeneralAgent(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllGeneralAdminUser();
  
  
  const change = (page: any) => {
    getAllGeneralAdminUser();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  
  //禁用或者开启
  const changedelFlag = (row: any) => { 
    var data = { "key": row.userId, "id": row.state };
    disableUsers(JSON.stringify(data)).then((res: any) => {
      if (res != "" && res.code == 0) {
        getAllGeneralAdminUser();
        layer.msg("操作成功", { time: 1000, icon: 1 });
      }
    })
  }
  
  //查询接口
  const searchUser = () => {
    page.current=1;
    getAllGeneralAdminUser();
  }
  
  
  
  const agent = reactive({
    userId: "",
    userName: "",
    password: "", 
    univalent:"", 
    origin:"", 
    
    proportion:"",
    generalRemark:"",
    deductionPosition:0,
    withinDays:"",
    verifyArr:[]
  })
  
  
  const updateUser = (row: any) => {
    agent.userId = row.userId;
    agent.userName = row.userName;
    agent.password = "";  
    agent.univalent = row.univalent;
    agent.origin = row.origin;
    
    agent.deductionPosition= row.deductionPosition;
    agent.proportion = row.proportion; 
    agent.verifyArr = row.verifyArr;  
    agent.withinDays = row.withinDays;  
    
    
    
    agent.generalRemark = row.generalRemark; 
    
    isDisabled.value = true;
    visible11.value = !visible11.value;
  }
  
  const layFormRef11 = ref();
  
  const visible11 = ref(false);
  
  const isDisabled = ref(false);
  
  const changeVisible11 = () => {
    agent.userId = "";
    agent.userName = "";
    agent.password = ""; 
    agent.univalent =""; 
    agent.origin ="";  
    agent.proportion = "";
    agent.generalRemark = ""; 
    agent.deductionPosition=0,
    agent.withinDays = "";  
    agent.verifyArr =[];  
    isDisabled.value = false;
    visible11.value = !visible11.value;
  }
  
  const action11 = ref([
    {
      text: "确认",
      callback: () => {
        addAgent(JSON.stringify(agent)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllGeneralAdminUser();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        visible11.value = false;
  
      }
    }
  ])
  
//结算
const settlement = (row: any) => {
  var data = { "key": row.userId }

  layer.confirm("请确定是否已结算”" + row.userName + "“代理",
    {
      btn: [
        {
          text: '确定', callback: (id: any) => {

            officialSettlementDccounts(JSON.stringify(data)).then((res: any) => {
              if (res != "" && res.code == 0) {
                getAllGeneralAdminUser();
                visible11.value = false;
                layer.msg("操作成功", { time: 1000, icon: 1 });
              }
            })



            layer.close(id);
          }
        },
        {
          text: '取消', callback: (id: any) => {
            layer.msg("取消");
            layer.close(id);
          }
        }
      ]
    }
  );

}

//一键登录
const  oneClickLogin=(row: any)=>{ 
  var data={"key":row.userId}; 
  adminOneClickLogin(JSON.stringify(data)).then((res: any) => {
    if (res!=""&&res.code == 0) { 
            setUserName(row.userName);
            setToken(res.data);
            layer.msg("登录成功", { icon : 1, time: 1000})
            window.location.reload();
        } 
      })
 
}



 
const changeStatistics = (page: any) => {
  getAllstatistics();
  }
  


const dataSourceStatistics = ref([]);
const pageStatistics = reactive({ current: 1, limit: 10, total: 0 });

const columnsStatistics = ref([
{ title: "访问量", key: "totalVisits", align: "center"},
    { title: "ip量", key: "totalIp", align: "center"},
    { title: "下载量", key: "totalDowds", align: "center"},
    { title: "安装量", key: "totalInvite", align: "center"}, 
    { title: "注册量", key: "totalRegister", align: "center" },  
    { title: "时间", key: "timeStr", align: "center" }, 
  ]);

const  isStatistics= ref(false);
const userId = ref('');
const  statistics=(row: any)=>{  
  userId.value=row.userId
  isStatistics.value=!isStatistics.value 
  getAllstatistics();
}






const getAllstatistics = () => {
    loading.value = true;
    var data = { "page": pageStatistics.current, "limit": pageStatistics.limit, "key": userId.value };
    getMeasure(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSourceStatistics.value = res.data;
        pageStatistics.total = res.count;
      } else {
        dataSourceStatistics.value = [];
        pageStatistics.total = 0;
      }
    })
  }

  
return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_switch = _resolveComponent("lay-switch")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_layer = _resolveComponent("lay-layer")!
  const _component_lay_card = _resolveComponent("lay-card")!
  const _component_lay_line = _resolveComponent("lay-line")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_form, {
                  model: search,
                  style: {"text-align":"start"},
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "代理账号",
                      prop: "username",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: search.key,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.key) = $event)),
                          placeholder: "请输入账号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, { mode: "inline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_button, {
                          type: "primary",
                          size: "sm",
                          onClick: searchUser
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_lay_button, {
                    size: "sm",
                    onClick: changeVisible11,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  state: _withCtx(({ row }) => [
                    _createVNode(_component_lay_switch, {
                      "model-value": row.state == 0 ? true : false,
                      onChange: ($event: any) => (changedelFlag(row)),
                      "onswitch-text": "正常",
                      "unswitch-text": "禁用"
                    }, null, 8, ["model-value", "onChange"])
                  ]),
                  totalDowds: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.totalDowds+row.closedTotalDowds), 1)
                  ]),
                  totalInvite: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.totalInvite+row.closedTotalInvite), 1)
                  ]),
                  totalRegister: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.totalRegister+row.closedTotalRegister), 1)
                  ]),
                  operator: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (check(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查看")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (statistics(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("统计")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (updateUser(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "danger",
                      onClick: ($event: any) => (oneClickLogin(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("一键登录")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  invitationCode: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (copyToClipboard(row.invitationCode))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("推广链接")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (copyToClipboard(row.logoUrl))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("LOGO链接")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  verifyStr: _withCtx(({ row }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.verifyArr, (verify) => {
                      return (_openBlock(), _createElementBlock("div", { key: verify }, [
                        (verify=='1')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_2, " ip "))
                          : (verify=='2')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_3, " 注册 "))
                            : (verify=='3')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_4, " 设备码 "))
                              : (verify=='4')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_5, " H5注册为准 "))
                                : (verify=='5')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, " 浏览器指纹 "))
                                  : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['800px', '630px'],
      btn: action11.value,
      title: "添加/修改"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_lay_form, {
            model: agent,
            ref_key: "layFormRef11",
            ref: layFormRef11,
            pane: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "账户",
                prop: "userName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: agent.userName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((agent.userName) = $event)),
                    disabled: isDisabled.value,
                    placeholder: "请输入账号"
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "密码",
                prop: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: agent.password,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((agent.password) = $event)),
                    type: "password",
                    placeholder: "无需修改请置空"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "单价",
                prop: "univalent"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: agent.univalent,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((agent.univalent) = $event)),
                    placeholder: "请输入单价"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "来源验证",
                prop: "origin"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: agent.origin,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((agent.origin) = $event)),
                    placeholder: "请输入来源验证"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "天数",
                prop: "withinDays"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: agent.withinDays,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((agent.withinDays) = $event)),
                    placeholder: "判断多少天之内是老用户"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "扣量位置",
                prop: "deductionPosition",
                mode: "inline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_select, {
                    modelValue: agent.deductionPosition,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((agent.deductionPosition) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select_option, {
                        value: 0,
                        label: "请选择"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 1,
                        label: "访问"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 2,
                        label: "点击"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 3,
                        label: "安装"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 4,
                        label: "注册"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (agent.deductionPosition!=0)
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 0,
                    label: "扣量比例",
                    prop: "proportion",
                    mode: "inline"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        modelValue: agent.proportion,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((agent.proportion) = $event)),
                        placeholder: "扣量百分比"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_lay_form_item, {
                label: "验证方式",
                prop: "verifyArr"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_select, {
                    modelValue: agent.verifyArr,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((agent.verifyArr) = $event)),
                    multiple: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select_option, {
                        value: "1",
                        label: "ip"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: "2",
                        label: "注册"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: "3",
                        label: "设备码"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: "4",
                        label: "H5注册为准"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: "5",
                        label: "浏览器指纹"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "备注",
                prop: "generalRemark"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_textarea, {
                    placeholder: "请输入备注",
                    modelValue: agent.generalRemark,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((agent.generalRemark) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"]),
    _createVNode(_component_lay_layer, {
      modelValue: isGeneralAgent.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((isGeneralAgent).value = $event)),
      shade: false,
      area: ['1200px', '800px'],
      title: "代理信息"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_lay_row, { space: "10" }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "账号" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.userName), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "单价" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.univalent), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "扣量规则" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.proportion) + "% ", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "代理人数" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.numberSubagents), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "今预览" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.visitsToday), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "总预览" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.totalVisits), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "今ip" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.todayIp), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "总ip" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.totalIp), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "今下载" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.dowdsToday), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "总下载" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.totalDowds+agentMyUserActivity.closedTotalDowds), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "今安装" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.inviteToday), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "总安装" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.totalInvite+agentMyUserActivity.closedTotalInvite), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "今注册" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.registerToday), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "总注册" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.totalRegister+agentMyUserActivity.closedTotalRegister), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "总充值" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.totalRecharge), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "总扣量" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.quantity), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "三天活跃度" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.threeDays), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "七天活跃度" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.sevenDays), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_col, { md: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_card, { title: "三十活跃度" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agentMyUserActivity.thirtyDays), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_lay_line)
              ]),
              _hoisted_10,
              _createVNode(_component_lay_table, {
                page: pageAgent,
                height: '100%',
                columns: columnsAgent.value,
                loading: loading.value,
                "data-source": dataSourceAgent.value,
                "selected-keys": selectedKeys.value,
                "onUpdate:selectedKeys": _cache[12] || (_cache[12] = ($event: any) => ((selectedKeys).value = $event)),
                onChange: changeAdminMyAgent,
                onSortChange: sortChange
              }, {
                state: _withCtx(({ row }) => [
                  (row.state == 0)
                    ? (_openBlock(), _createElementBlock("samp", _hoisted_11, "正常"))
                    : (row.state == 1)
                      ? (_openBlock(), _createElementBlock("samp", _hoisted_12, "禁用"))
                      : _createCommentVNode("", true)
                ]),
                totalDowds: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.totalDowds+row.closedTotalDowds), 1)
                ]),
                totalInvite: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.totalInvite+row.closedTotalInvite), 1)
                ]),
                totalRegister: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.totalRegister+row.closedTotalRegister), 1)
                ]),
                invitationCode: _withCtx(({ row }) => [
                  _createVNode(_component_lay_button, {
                    size: "xs",
                    type: "primary",
                    onClick: ($event: any) => (copyToClipboard(row.invitationCode))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("推广链接")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_lay_button, {
                    size: "xs",
                    type: "primary",
                    onClick: ($event: any) => (copyToClipboard(row.logoUrl))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("LOGO链接")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_lay_layer, {
      modelValue: isStatistics.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((isStatistics).value = $event)),
      shade: false,
      area: ['1000px', '600px'],
      title: "统计列表"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_lay_table, {
            page: pageStatistics,
            height: '100%',
            columns: columnsStatistics.value,
            loading: loading.value,
            "data-source": dataSourceStatistics.value,
            "selected-keys": selectedKeys.value,
            "onUpdate:selectedKeys": _cache[14] || (_cache[14] = ($event: any) => ((selectedKeys).value = $event)),
            onChange: changeStatistics,
            onSortChange: sortChange
          }, null, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})